<script>
    import { hackCuts } from '../../store.js';
</script>

<div class="content">
    <label>Ctrl + 1</label>
    <input type="text"  bind:value={hackCuts.c1}/>
    <label>Ctrl + 2</label>
    <input type="text"  bind:value={hackCuts.c2}/>
    <label>Ctrl + 3</label>
    <input type="text"  bind:value={hackCuts.c3} />
</div>

<style>
    .add-bar button {
        width: 100%;
    }
    .action-bar {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
    }
    .row {
        border: 1px solid black;
    }
    .content {
      display: grid;
      grid-template-columns: 20% 80%;
      grid-column-gap: 10px;
    }

    .content img {
        width: 200px;
        object-fit: contain;
    }
</style>
